import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";

import '../styles/dashboard.css';
import { CgDollar } from "react-icons/cg";
import { FaCubes } from "react-icons/fa";
import { GiWallet } from "react-icons/gi";
import { IoIosPeople } from "react-icons/io";
import { BsFillCreditCard2BackFill, BsCloudDownloadFill } from "react-icons/bs";

import TradingViewWidget from '../../LiveTrading/templates/TradingViewWidget';
import VerificatonPopUp from './VerificatonPopUp';
import TradeHistory from '../../LiveTrading/templates/TradeHistory';


const Dashboard = () => {
  const { account } = useSelector((state) => state.accounts);
  const [canc, setCanc] = useState(true)
  const dispatch = useDispatch()

  // useEffect(() => {
  //   dispatch(getAccount(user.result._id));
  // }, [dispatch, user.result._id])


  useEffect(() => {
    if ((account?.status === "Demo") && (account?.requestVerification === false)) {
      setTimeout(() => {
        setCanc(true)
      }, 3000)
    } else {
      setCanc(false)
    }
  }, [account?.status, account?.requestVerification])

  return (
    <>
      <div className="dashboard">
        <div className="dashboard-container">
          <div className="profile">
            <div className="pxp">
              <div className="pix"><p>{account?.firstName.charAt(0)}{account?.lastName.charAt(0)}</p></div>
            </div>
            <div className="name">
              <h4>Welcome <span> @{account?.userName}</span></h4>
              <h5> {account?.email}</h5>
            </div>
            <div className="ref">
              <h4>Referral ID: <span>{account?.ref}</span></h4>
            </div>
          </div>
          <ul className="status">
            <li className="stat">
              <h4>Account Status</h4>
              <p className={((account?.requestVerification === true) && (account?.status === "Demo")) ? " verifReq" : " "}>{((account?.requestVerification === true) && (account?.status === "Demo")) ? "Verification in process" : account?.status} </p>
            </li>
            <li className={(account?.level === "Diamond") ? "diamond" :
              (account?.level === "Silver") ? "silver" :
                (account?.level === "Gold") ? "gold" :
                  (account?.level === "Platinum") ? "platinum" : "basic"}>
              <h4>Account Level:</h4>
              <p>{account?.level}</p>
            </li>
          </ul>
          <div className="wallet-balance">
            <ul>
              <li>
                <CgDollar />
                <p>Main Account:</p>
                <h4>${account?.transaction?.balance?.mainAccount}</h4>
              </li>
              <li>
                <GiWallet />
                <p>Profit Balance:</p>
                <h4>${account?.transaction?.balance?.interestBonus}</h4>
              </li>
              <li>
                <FaCubes />
                <p>total investments</p>
                <h4>${account?.transaction?.balance?.invested}</h4>
              </li>
              <li>
                <BsFillCreditCard2BackFill />
                <p>total deposit</p>
                <h4>${account?.transaction?.balance?.deposited}</h4>
              </li>
              <li>
                <BsCloudDownloadFill />
                <p>total withdraw</p>
                <h4>${account?.transaction?.balance?.withdrawn}</h4>
              </li>
              <li>
                <IoIosPeople />
                <p>referral Bonus</p>
                <h4>${account?.transaction?.balance?.referralBonus}</h4>
              </li>
            </ul>
          </div>
          <div className="dashy">
            <div className="tradeProgress">
              <h3>{account?.trade?.stock} Trade in Progress</h3>
              <p>{account?.trade?.progress}% Completed</p>
              <div className="statusBar">
                <div className="imageBar">
                  <p style={{ "--i": account?.trade?.progress }}></p>
                </div>
              </div>
            </div>
            <div className="trad-hist">
              <TradeHistory />
            </div>
            <div className="infomat">
              <h4>Trade Binary Options and digital options with us. Pick the type of options that best suits your trading style and profitability expectations.</h4>
            </div>
            <div className="tradeWidg">
              <TradingViewWidget />
            </div>
          </div>
        </div>
        {
          canc && <VerificatonPopUp account={account} canc={canc} setCanc={setCanc} />
        }
      </div>
    </>
  )
}

export default Dashboard